// ─── Parts Catalog — Master list of all part types ──────────
// This is the static fallback. Supabase parts_catalog table is authoritative.
// Categories are ordered for display. Parts within each category are ordered by display_order.

export const PARTS_CATALOG_CATEGORIES = [
  'Cut Types',
  'Engine & Transmission',
  'Engine Bundles',
  'Drivetrain & Axles',
  'Suspension & Steering',
  'Brakes',
  'Body Panels',
  'Lights',
  'Glass',
  'Interior',
  'Doors & Locks',
  'Windows & Regulators',
  'Exhaust',
  'Fuel',
  'Cooling & AC',
  'Electrical',
  'Wheels & Tyres',
  'Mirrors',
  'Complete Sets',
];

export const PARTS_CATALOG = [
  // ── Cut Types
  { part_name: 'CBU (Complete Built Unit)',          category: 'Cut Types', display_order: 1,  is_common: true  },
  { part_name: 'CKD',                               category: 'Cut Types', display_order: 2,  is_common: true  },
  { part_name: 'CKD W/O Scrap (Frame etc)',          category: 'Cut Types', display_order: 3,  is_common: false },
  { part_name: 'CKD W/O Engine',                     category: 'Cut Types', display_order: 4,  is_common: false },
  { part_name: 'CKD W/O Engine W/O Catalyst',        category: 'Cut Types', display_order: 5,  is_common: false },
  { part_name: 'CKD W/O Catalyst (All) W/O Scrap',   category: 'Cut Types', display_order: 6,  is_common: false },
  { part_name: 'Half Cut (H/CUT)',                   category: 'Cut Types', display_order: 7,  is_common: true  },
  { part_name: 'H/CUT W/O Catalyst',                category: 'Cut Types', display_order: 8,  is_common: false },
  { part_name: 'Nose Cut',                           category: 'Cut Types', display_order: 9,  is_common: true  },
  { part_name: 'Roof Cut',                           category: 'Cut Types', display_order: 10, is_common: false },

  // ── Engine & Transmission
  { part_name: 'Engine (Complete)',     category: 'Engine & Transmission', display_order: 1, is_common: true  },
  { part_name: 'Engine Mount',         category: 'Engine & Transmission', display_order: 2, is_common: false },
  { part_name: 'Engine Cover',         category: 'Engine & Transmission', display_order: 3, is_common: false },
  { part_name: 'Engine Computer (ECU)',category: 'Engine & Transmission', display_order: 4, is_common: false },
  { part_name: 'M/T Mission (Manual)', category: 'Engine & Transmission', display_order: 5, is_common: true  },
  { part_name: 'A/T Mission (Auto)',   category: 'Engine & Transmission', display_order: 6, is_common: true  },
  { part_name: 'Mission Computer',     category: 'Engine & Transmission', display_order: 7, is_common: false },
  { part_name: 'Ignition Coil',        category: 'Engine & Transmission', display_order: 8, is_common: false },
  { part_name: 'Turbo',                category: 'Engine & Transmission', display_order: 9, is_common: false },

  // ── Engine Bundles
  { part_name: 'Engine + Mission',                                       category: 'Engine Bundles', display_order: 1, is_common: true  },
  { part_name: 'Engine + Mission W/O Catalyst (Manifold)',               category: 'Engine Bundles', display_order: 2, is_common: false },
  { part_name: 'Engine + Mission F W/Strut W/O Catalyst (Manifold)',     category: 'Engine Bundles', display_order: 3, is_common: false },
  { part_name: 'Engine + Mission F W/Strut',                             category: 'Engine Bundles', display_order: 4, is_common: false },
  { part_name: 'Engine + Mission F Axle + R Axle Set',                   category: 'Engine Bundles', display_order: 5, is_common: false },

  // ── Drivetrain & Axles
  { part_name: 'F Axle',            category: 'Drivetrain & Axles', display_order: 1,  is_common: true  },
  { part_name: 'R Axle',            category: 'Drivetrain & Axles', display_order: 2,  is_common: true  },
  { part_name: 'F Diff',            category: 'Drivetrain & Axles', display_order: 3,  is_common: false },
  { part_name: 'R Diff',            category: 'Drivetrain & Axles', display_order: 4,  is_common: false },
  { part_name: 'F Drive Shaft RH',  category: 'Drivetrain & Axles', display_order: 5,  is_common: false },
  { part_name: 'F Drive Shaft LH',  category: 'Drivetrain & Axles', display_order: 6,  is_common: false },
  { part_name: 'R Drive Shaft RH',  category: 'Drivetrain & Axles', display_order: 7,  is_common: false },
  { part_name: 'R Drive Shaft LH',  category: 'Drivetrain & Axles', display_order: 8,  is_common: false },
  { part_name: 'F Propeller Shaft', category: 'Drivetrain & Axles', display_order: 9,  is_common: false },
  { part_name: 'R Propeller Shaft', category: 'Drivetrain & Axles', display_order: 10, is_common: false },

  // ── Suspension & Steering
  { part_name: 'F Strut RH',          category: 'Suspension & Steering', display_order: 1,  is_common: false },
  { part_name: 'F Strut LH',          category: 'Suspension & Steering', display_order: 2,  is_common: false },
  { part_name: 'R Strut RH',          category: 'Suspension & Steering', display_order: 3,  is_common: false },
  { part_name: 'R Strut LH',          category: 'Suspension & Steering', display_order: 4,  is_common: false },
  { part_name: 'F Member (Subframe)', category: 'Suspension & Steering', display_order: 5,  is_common: false },
  { part_name: 'R Member',            category: 'Suspension & Steering', display_order: 6,  is_common: false },
  { part_name: 'Rack and Pinion',     category: 'Suspension & Steering', display_order: 7,  is_common: false },
  { part_name: 'Power Steering Pump', category: 'Suspension & Steering', display_order: 8,  is_common: false },
  { part_name: 'Steering Column',     category: 'Suspension & Steering', display_order: 9,  is_common: false },
  { part_name: 'Steering Wheel',      category: 'Suspension & Steering', display_order: 10, is_common: false },

  // ── Brakes
  { part_name: 'ABS',                  category: 'Brakes', display_order: 1, is_common: false },
  { part_name: 'Brake Master',         category: 'Brakes', display_order: 2, is_common: false },
  { part_name: 'Front Knuckle Hub RH', category: 'Brakes', display_order: 3, is_common: false },
  { part_name: 'Front Knuckle Hub LH', category: 'Brakes', display_order: 4, is_common: false },
  { part_name: 'Rear Knuckle Hub RH',  category: 'Brakes', display_order: 5, is_common: false },
  { part_name: 'Rear Knuckle Hub LH',  category: 'Brakes', display_order: 6, is_common: false },

  // ── Body Panels
  { part_name: 'Bonnet',          category: 'Body Panels', display_order: 1,  is_common: true  },
  { part_name: 'F Bumper',        category: 'Body Panels', display_order: 2,  is_common: true  },
  { part_name: 'R Bumper',        category: 'Body Panels', display_order: 3,  is_common: true  },
  { part_name: 'Fender RH',       category: 'Body Panels', display_order: 4,  is_common: false },
  { part_name: 'Fender LH',       category: 'Body Panels', display_order: 5,  is_common: false },
  { part_name: 'F Door RH',       category: 'Body Panels', display_order: 6,  is_common: false },
  { part_name: 'F Door LH',       category: 'Body Panels', display_order: 7,  is_common: false },
  { part_name: 'R Door RH',       category: 'Body Panels', display_order: 8,  is_common: false },
  { part_name: 'R Door LH',       category: 'Body Panels', display_order: 9,  is_common: false },
  { part_name: 'Rear Gate',       category: 'Body Panels', display_order: 10, is_common: false },
  { part_name: 'Trunk',           category: 'Body Panels', display_order: 11, is_common: false },
  { part_name: 'Side Step RH',    category: 'Body Panels', display_order: 12, is_common: false },
  { part_name: 'Side Step LH',    category: 'Body Panels', display_order: 13, is_common: false },
  { part_name: 'Grille',          category: 'Body Panels', display_order: 14, is_common: false },
  { part_name: 'Cowl Top',        category: 'Body Panels', display_order: 15, is_common: false },
  { part_name: 'Roof Carrier',    category: 'Body Panels', display_order: 16, is_common: false },
  { part_name: 'Siding (AORI) R', category: 'Body Panels', display_order: 17, is_common: false },
  { part_name: 'Siding (AORI) RH',category: 'Body Panels', display_order: 18, is_common: false },
  { part_name: 'Siding (AORI) LH',category: 'Body Panels', display_order: 19, is_common: false },
  { part_name: 'Ladder',          category: 'Body Panels', display_order: 20, is_common: false },

  // ── Lights
  { part_name: 'Head Light RH',          category: 'Lights', display_order: 1, is_common: true  },
  { part_name: 'Head Light LH',          category: 'Lights', display_order: 2, is_common: true  },
  { part_name: 'Tail Lamp RH',           category: 'Lights', display_order: 3, is_common: false },
  { part_name: 'Tail Lamp LH',           category: 'Lights', display_order: 4, is_common: false },
  { part_name: 'Rear Finisher Lamp RH',  category: 'Lights', display_order: 5, is_common: false },
  { part_name: 'Rear Finisher Lamp LH',  category: 'Lights', display_order: 6, is_common: false },
  { part_name: 'High-Mounted Stop Lamp', category: 'Lights', display_order: 7, is_common: false },
  { part_name: 'Right Ballast',          category: 'Lights', display_order: 8, is_common: false },
  { part_name: 'Left Ballast',           category: 'Lights', display_order: 9, is_common: false },

  // ── Glass
  { part_name: 'F Glass RH',  category: 'Glass', display_order: 1, is_common: false },
  { part_name: 'F Glass LH',  category: 'Glass', display_order: 2, is_common: false },
  { part_name: 'R Glass RH',  category: 'Glass', display_order: 3, is_common: false },
  { part_name: 'R Glass LH',  category: 'Glass', display_order: 4, is_common: false },
  { part_name: 'Rear Glass',  category: 'Glass', display_order: 5, is_common: false },

  // ── Interior
  { part_name: 'Dashboard',      category: 'Interior', display_order: 1,  is_common: false },
  { part_name: 'Driver Seat',    category: 'Interior', display_order: 2,  is_common: false },
  { part_name: 'Assistant Seat', category: 'Interior', display_order: 3,  is_common: false },
  { part_name: 'Rear Seat',      category: 'Interior', display_order: 4,  is_common: false },
  { part_name: 'Center Seat',    category: 'Interior', display_order: 5,  is_common: false },
  { part_name: 'Headrest',       category: 'Interior', display_order: 6,  is_common: false },
  { part_name: 'Sun Visor',      category: 'Interior', display_order: 7,  is_common: false },
  { part_name: 'Audio',          category: 'Interior', display_order: 8,  is_common: false },
  { part_name: 'Speed Meter',    category: 'Interior', display_order: 9,  is_common: false },
  { part_name: 'Dimmer Switch',  category: 'Interior', display_order: 10, is_common: false },

  // ── Doors & Locks
  { part_name: 'Door Lock Actuator F RH',      category: 'Doors & Locks', display_order: 1, is_common: false },
  { part_name: 'Door Lock Actuator F LH',      category: 'Doors & Locks', display_order: 2, is_common: false },
  { part_name: 'Door Lock Actuator R RH',      category: 'Doors & Locks', display_order: 3, is_common: false },
  { part_name: 'Door Lock Actuator R LH',      category: 'Doors & Locks', display_order: 4, is_common: false },
  { part_name: 'Door Lock Actuator Rear Gate', category: 'Doors & Locks', display_order: 5, is_common: false },
  { part_name: 'Outside Door Handle F/RH',     category: 'Doors & Locks', display_order: 6, is_common: false },
  { part_name: 'Outside Door Handle F/LH',     category: 'Doors & Locks', display_order: 7, is_common: false },
  { part_name: 'Outside Door Handle R/RH',     category: 'Doors & Locks', display_order: 8, is_common: false },
  { part_name: 'Outside Door Handle R/LH',     category: 'Doors & Locks', display_order: 9, is_common: false },

  // ── Windows & Regulators
  { part_name: 'Power Window Switch',              category: 'Windows & Regulators', display_order: 1, is_common: false },
  { part_name: 'Front Right Regulator Motor',       category: 'Windows & Regulators', display_order: 2, is_common: false },
  { part_name: 'Front Left Regulator Motor',        category: 'Windows & Regulators', display_order: 3, is_common: false },
  { part_name: 'Rear Right Regulator Motor',        category: 'Windows & Regulators', display_order: 4, is_common: false },
  { part_name: 'Rear Left Regulator Motor',         category: 'Windows & Regulators', display_order: 5, is_common: false },
  { part_name: 'Rear Power Sliding Door Motor RH',  category: 'Windows & Regulators', display_order: 6, is_common: false },
  { part_name: 'Rear Power Sliding Door Motor LH',  category: 'Windows & Regulators', display_order: 7, is_common: false },
  { part_name: 'Rear Power Slide Door Motor RH',    category: 'Windows & Regulators', display_order: 8, is_common: false },
  { part_name: 'Rear Power Slide Door Motor LH',    category: 'Windows & Regulators', display_order: 9, is_common: false },

  // ── Exhaust
  { part_name: 'F Exhaust Pipe',    category: 'Exhaust', display_order: 1, is_common: false },
  { part_name: 'Center Pipe',       category: 'Exhaust', display_order: 2, is_common: false },
  { part_name: 'Muffler Catalyst',  category: 'Exhaust', display_order: 3, is_common: false },
  { part_name: 'R Muffler',         category: 'Exhaust', display_order: 4, is_common: false },
  { part_name: 'Catalyst',          category: 'Exhaust', display_order: 5, is_common: false },

  // ── Fuel
  { part_name: 'Fuel Pump', category: 'Fuel', display_order: 1, is_common: false },
  { part_name: 'Fuel Tank', category: 'Fuel', display_order: 2, is_common: false },

  // ── Cooling & AC
  { part_name: 'Radiator (+ Fan)', category: 'Cooling & AC', display_order: 1, is_common: true  },
  { part_name: 'Radiator Fan',     category: 'Cooling & AC', display_order: 2, is_common: false },
  { part_name: 'A/C Switch',       category: 'Cooling & AC', display_order: 3, is_common: false },
  { part_name: 'AC Compressor',    category: 'Cooling & AC', display_order: 4, is_common: false },
  { part_name: 'Blower Motor',     category: 'Cooling & AC', display_order: 5, is_common: false },

  // ── Electrical
  { part_name: 'Engine CP',         category: 'Electrical', display_order: 1, is_common: false },
  { part_name: 'Mission CP',        category: 'Electrical', display_order: 2, is_common: false },
  { part_name: 'Integration Relay', category: 'Electrical', display_order: 3, is_common: false },
  { part_name: 'Air Flow Meter',    category: 'Electrical', display_order: 4, is_common: false },
  { part_name: 'Hybrid Battery',    category: 'Electrical', display_order: 5, is_common: false },
  { part_name: 'Tailgate Damper',   category: 'Electrical', display_order: 6, is_common: false },

  // ── Wheels & Tyres
  { part_name: 'Rim ALM (Aluminum)', category: 'Wheels & Tyres', display_order: 1, is_common: false },
  { part_name: 'Rim Iron',           category: 'Wheels & Tyres', display_order: 2, is_common: false },
  { part_name: 'Tire with Rim ALM',  category: 'Wheels & Tyres', display_order: 3, is_common: false },
  { part_name: 'Tire with Rim Iron', category: 'Wheels & Tyres', display_order: 4, is_common: false },
  { part_name: 'Wheel',              category: 'Wheels & Tyres', display_order: 5, is_common: false },

  // ── Mirrors
  { part_name: 'Mirror RH', category: 'Mirrors', display_order: 1, is_common: false },
  { part_name: 'Mirror LH', category: 'Mirrors', display_order: 2, is_common: false },

  // ── Complete Sets
  { part_name: 'EG W/S R Axle Catalyst (ALL) ABS Brake Master Tyre Set',  category: 'Complete Sets', display_order: 1, is_common: false },
  { part_name: 'EG W/S R Axle W/O Catalyst ABS Brake Master Tyre Set',    category: 'Complete Sets', display_order: 2, is_common: false },
];

// Helper: get catalog grouped by category (ordered)
export function getPartsCatalogGrouped(catalog) {
  const data = catalog || PARTS_CATALOG;
  const grouped = {};
  PARTS_CATALOG_CATEGORIES.forEach(cat => { grouped[cat] = []; });
  data.forEach(part => {
    if (!grouped[part.category]) grouped[part.category] = [];
    grouped[part.category].push(part);
  });
  // Sort each group by display_order
  Object.values(grouped).forEach(parts => parts.sort((a, b) => a.display_order - b.display_order));
  // Remove empty categories
  Object.keys(grouped).forEach(cat => { if (grouped[cat].length === 0) delete grouped[cat]; });
  return grouped;
}

// Helper: get only common parts (for quick selection)
export function getCommonParts(catalog) {
  return (catalog || PARTS_CATALOG).filter(p => p.is_common);
}
